webpackJsonp([114276838955818,60335399758886],{

/***/ 125:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(266);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(125);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return Glamor.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamorous = __webpack_require__(30);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slideItIn = _glamor.css.keyframes('slideItIn', {
	  '0%': {
	    marginLeft: '200%',
	    width: '300%'
	  },
	  '100%': {
	    marginLeft: '0%',
	    width: '300%'
	  }
	});
	
	var bottomPulsate = _glamor.css.keyframes('bottomPulsate', {
	  '0%': { opacity: 0.85, textShadow: '0 0 20px #ff0000' },
	  '25%': { opacity: 0.55, textShadow: '0 0 25px #bb3322' },
	  '50%': { opacity: 0.75, textShadow: '0 0 20px #dd2222' },
	  '75%': { opacity: 0.55, textShadow: '0 0 25px #aa4433' },
	  '100%': { opacity: 0.85, textShadow: '0 0 20px #ff0000' }
	});
	
	var componentGrid = (0, _glamor.css)({
	  display: 'grid',
	  gridTemplateColumns: 'repeat(12, 8%)',
	  gridTemplateRows: '33px 33px',
	  borderTop: '1px solid #888',
	  width: '100%',
	  justifyContent: 'space-evenly'
	});
	
	var iconP = (0, _glamor.css)({
	  margin: 0,
	  padding: '5px 0 0',
	  '@media (min-width: 768px)': {
	    animation: slideItIn + ' 2s'
	  }
	});
	
	var iconA = (0, _glamor.css)({
	  margin: 0,
	  padding: 0
	});
	
	var iconImg = (0, _glamor.css)({
	  width: 20,
	  height: 20
	});
	
	var iconSquare = (0, _glamor.css)({
	  '&:hover': {
	    borderRadius: '20%'
	  }
	});
	
	var iconCircle = (0, _glamor.css)({
	  '&:hover': {
	    borderRadius: '50%'
	  }
	});
	
	var iconLinkedIn = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(0, 119, 181, 0.75)',
	    boxShadow: '0 0 6px 2px rgba(0, 119, 181, 0.8)'
	  }
	});
	
	var iconGithub = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(24, 23, 23, 0.3)',
	    boxShadow: '0 0 6px 3px rgba(24, 23, 23, 0.5)'
	  }
	});
	
	var iconTwitter = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(29, 161, 242, 0.75)',
	    boxShadow: '0 0 6px 3px rgba(29, 161, 242, 0.8)'
	  }
	});
	
	var iconInstagram = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(228, 64, 95, 0.75)',
	    boxShadow: '0 0 6px 2px rgba(228, 64, 95, 0.8)'
	  }
	});
	
	var iconGooglePlus = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(220, 78, 65, 0.75)',
	    boxShadow: '0 0 6px 3px rgba(220, 78, 65, 0.8)'
	  }
	});
	
	var iconSnapchat = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(255, 252, 0, 0.75)',
	    boxShadow: '0 0 6px 2px rgba(255, 252, 0, 0.8)'
	  }
	});
	
	var iconSteam = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(0, 0, 0, 0.3)',
	    boxShadow: '0 0 6px 3px rgba(0, 0, 0, 0.5)'
	  }
	});
	
	var iconPinterest = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(189, 8, 28, 0.75)',
	    boxShadow: '0 0 6px 3px rgba(189, 8, 28, 0.8)'
	  }
	});
	
	var iconCodeWars = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(173, 44, 39, 0.75)',
	    boxShadow: '0 0 6px 3px rgba(173, 44, 39, 0.8)'
	  }
	});
	
	var iconStackOverflow = (0, _glamor.css)({
	  '&:hover': {
	    background: 'rgba(254, 122, 22, 0.75)',
	    boxShadow: '0 0 6px 2px rgba(254, 122, 22, 0.8)'
	  }
	});
	
	var navLink = (0, _glamor.css)({
	  color: '#000',
	  fontStyle: 'normal',
	  '&:hover': {
	    textDecoration: 'none',
	    animation: bottomPulsate + ' 2s ease-in infinite'
	  }
	});
	
	var footerParagraph = (0, _glamor.css)({
	  gridColumn: 'span 3',
	  fontSize: 8,
	  textAlign: 'right',
	  textTransform: 'uppercase',
	  '@media (min-width: 768px)': {
	    fontSize: 12,
	    fontWeight: 600,
	    textAlign: 'left',
	    margin: 'auto 0',
	    gridColumn: 'span 2',
	    animation: slideItIn + ' 2s'
	  }
	});
	
	var leftFooterParagraph = (0, _glamor.css)({
	  textAlign: 'left'
	});
	
	var copyrightParagraph = (0, _glamor.css)({
	  gridColumn: 'span 12',
	  fontSize: 5,
	  textAlign: 'center',
	  textTransform: 'none',
	  position: 'absolute',
	  left: '1rem',
	  bottom: -30,
	  '@media (min-width: 768px)': {
	    position: 'relative',
	    bottom: 'inherit',
	    left: 'inherit',
	    fontSize: 12,
	    fontWeight: 600,
	    textAlign: 'left',
	    margin: 'auto 0',
	    gridColumn: 'span 4',
	    animation: slideItIn + ' 2s'
	  }
	});
	
	var IconSquare = function IconSquare(props) {
	  return Glamor.createElement(
	    'p',
	    { className: iconP },
	    Glamor.createElement(
	      'a',
	      { className: iconA, href: props.url, target: '_blank' },
	      Glamor.createElement('img', { className: iconImg + ' ' + iconSquare + ' ' + props.iconSpecific, src: props.imgUrl, alt: props.altText })
	    )
	  );
	};
	
	var IconCircle = function IconCircle(props) {
	  return Glamor.createElement(
	    'p',
	    { className: iconP },
	    Glamor.createElement(
	      'a',
	      { className: iconA, href: props.url, target: '_blank' },
	      Glamor.createElement('img', { className: iconImg + ' ' + iconCircle + ' ' + props.iconSpecific, src: props.imgUrl, alt: props.altText })
	    )
	  );
	};
	
	var _ref = {};
	var FooterLink = function FooterLink(props) {
	  return Glamor.createElement(
	    'p',
	    { className: props.style },
	    Glamor.createElement(
	      _gatsbyLink2.default,
	      { className: navLink, to: props.url, css: _ref },
	      props.urlName
	    )
	  );
	};
	
	var _ref2 = { fontWeight: '600' };
	
	exports.default = function () {
	  return Glamor.createElement(
	    'footer',
	    { className: componentGrid },
	    Glamor.createElement(
	      'p',
	      { css: {
	          gridColumn: 'span 2',
	          fontSize: 9,
	          margin: 'auto 0',
	          textTransform: 'uppercase',
	          '@media (min-width: 768px)': {
	            fontSize: 14,
	            animation: slideItIn + ' 2s'
	          }
	        }
	      },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact-me/', className: navLink, css: _ref2 },
	        'Email Me'
	      )
	    ),
	    Glamor.createElement(IconSquare, {
	      iconSpecific: iconLinkedIn,
	      url: 'https://linkedin.com/in/russellschmidt',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/linkedin.svg',
	      altText: 'LinkedIn russellschmidt profile'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconGithub,
	      url: 'https://github.com/russellschmidt',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/github.svg',
	      altText: 'GitHub russellschmidt profile'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconTwitter,
	      url: 'https://twitter.com/russ_eel',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/twitter.svg',
	      altText: 'Twitter profile @russ-eel'
	    }),
	    Glamor.createElement(IconSquare, {
	      iconSpecific: iconInstagram,
	      url: 'https://www.instagram.com/russ_eel/',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/instagram.svg',
	      altText: 'Instagram @russ_eel'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconGooglePlus,
	      url: 'https://plus.google.com/u/0/115439838839649200716',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/googleplus.svg',
	      altText: 'Google+ Google Plus everyone\'s favorite social site'
	    }),
	    Glamor.createElement(IconSquare, {
	      iconSpecific: iconSnapchat,
	      url: 'http://snapchat.com/add/rms-one',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/snapchat.svg',
	      altText: 'Snapchat @rms-one'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconSteam,
	      url: 'http://steamcommunity.com/id/russ-eel/',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/steam.svg',
	      altText: 'Steam user russ-eel'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconPinterest,
	      url: 'https://www.pinterest.com/rschmidt0378/',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/pinterest.svg',
	      altText: 'Pinterest rschmidt0378'
	    }),
	    Glamor.createElement(IconCircle, {
	      iconSpecific: iconCodeWars,
	      url: 'https://www.codewars.com/users/russellschmidt',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/codewars.svg',
	      altText: 'CodeWars Russell Schmidt profile'
	    }),
	    Glamor.createElement(IconSquare, {
	      iconSpecific: iconStackOverflow,
	      url: 'https://stackoverflow.com/users/1834685/russell-schmidt',
	      imgUrl: 'https://s3.amazonaws.com/russell-personal/social-icons/stackoverflow.svg',
	      altText: 'Stack Overflow Russell Schmidt profile'
	    }),
	    Glamor.createElement(
	      'p',
	      { className: copyrightParagraph },
	      '\xA9 ',
	      new Date().getFullYear(),
	      ' Russell Schmidt - All Rights Reserved'
	    ),
	    Glamor.createElement(FooterLink, { style: footerParagraph + ' ' + leftFooterParagraph, url: '/privacy/', urlName: 'Privacy Policy' }),
	    Glamor.createElement(FooterLink, { style: footerParagraph, url: '/terms-of-service/', urlName: 'Terms of Service' }),
	    Glamor.createElement(FooterLink, { style: footerParagraph, url: '/rss.xml', urlName: 'RSS Feed' }),
	    Glamor.createElement(FooterLink, { style: footerParagraph, url: '/sitemap.xml', urlName: 'Site Map' })
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamorous = __webpack_require__(30);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(10);
	
	var _typography = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsate = _glamor.css.keyframes('pulsate', {
	  '0%': { opacity: 0.8, textShadow: "0 0 25px #f80" },
	  '33%': { opacity: 0.6, textShadow: "0 0 25px #0f8" },
	  '66%': { opacity: 0.8, textShadow: "0 0 25px #0ff" },
	  '100%': { opacity: 0.6, textShadow: "0 0 25px #80f" }
	});
	
	var slideItIn = _glamor.css.keyframes('slideItIn', {
	  '0%': {
	    marginLeft: '200%',
	    width: '300%'
	  },
	  '100%': {
	    marginLeft: '0%',
	    width: '300%'
	  }
	});
	
	var componentGrid = (0, _glamor.css)({
	  display: "grid",
	  gridTemplateColumns: "repeat(12, 8%)",
	  gridTemplateRows: "auto",
	  borderBottom: "1px solid #888",
	  width: "100%",
	  justifyContent: "space-evenly"
	});
	
	var navHeader = (0, _glamor.css)({
	  marginTop: (0, _typography.rhythm)(1),
	  marginBottom: (0, _typography.rhythm)(1 / 2),
	  textAlign: "left",
	  gridColumn: "span 2",
	  animation: slideItIn + " 2s",
	  "@media (max-width: 768px)": {
	    gridColumn: "span 3",
	    textAlign: "right",
	    animation: "none",
	    marginTop: (0, _typography.rhythm)(2 / 3),
	    marginBottom: (0, _typography.rhythm)(1 / 3)
	  }
	});
	
	var logo = (0, _glamor.css)({
	  gridColumn: "1/7",
	  textAlign: "left",
	  "@media (max-width: 768px)": {
	    gridColumn: "span 3",
	    textAlign: "left"
	  }
	});
	
	var rightLink = (0, _glamor.css)({
	  "@media (max-width: 768px)": {
	    textAlign: "right"
	  }
	});
	
	var navLink = (0, _glamor.css)({
	  color: "#000",
	  fontStyle: "normal",
	  "&:hover": {
	    textDecoration: "none",
	    animation: pulsate + " 2s ease-in-out infinite"
	  },
	  "@media (max-width: 768px)": {
	    fontSize: (0, _typography.rhythm)(1 / 3),
	    textAlign: "center",
	    gridColumn: "span 3"
	  }
	});
	
	var navLogo = (0, _glamor.css)({});
	
	exports.default = function () {
	  return Glamor.createElement(
	    "nav",
	    { className: componentGrid },
	    Glamor.createElement(
	      "h6",
	      { className: navHeader + " " + logo },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { className: navLink + " " + navLogo, to: "/" },
	        "RUSSELL SCHMIDT"
	      )
	    ),
	    Glamor.createElement(
	      "h6",
	      { className: navHeader },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { className: navLink, to: "/portfolio/" },
	        "PORTFOLIO"
	      )
	    ),
	    Glamor.createElement(
	      "h6",
	      { className: navHeader },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { className: navLink, to: "/blog/" },
	        "BLOG"
	      )
	    ),
	    Glamor.createElement(
	      "h6",
	      { className: navHeader + " " + rightLink },
	      Glamor.createElement(
	        _gatsbyLink2.default,
	        { className: navLink, to: "/about/" },
	        "ABOUT"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamor = __webpack_require__(10);
	
	var _Footer = __webpack_require__(260);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _TopNav = __webpack_require__(265);
	
	var _TopNav2 = _interopRequireDefault(_TopNav);
	
	__webpack_require__(814);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var container = (0, _glamor.css)({
	  margin: "0 auto",
	  maxWidth: 1280,
	  height: "100%",
	  padding: "0 1rem"
	
	});
	
	var topContainer = (0, _glamor.css)({
	  height: 100,
	  width: "100%"
	});
	
	var bodyContainer = (0, _glamor.css)({
	  minHeight: "calc(100vh - 280px)",
	  "@media (max-width: 768px)": {
	    minHeight: "calc(100vh - 270px)"
	  }
	});
	
	var bottomContainer = (0, _glamor.css)({
	  height: 70,
	  width: "100%"
	});
	
	var _ref = container;
	var _ref2 = topContainer;
	var _ref3 = bodyContainer;
	var _ref4 = bottomContainer;
	
	exports.default = function (_ref5) {
	  var children = _ref5.children;
	  return Glamor.createElement(
	    "div",
	    { css: _ref },
	    Glamor.createElement(
	      "div",
	      { css: _ref2 },
	      Glamor.createElement(_TopNav2.default, null)
	    ),
	    Glamor.createElement(
	      "div",
	      { css: _ref3 },
	      children()
	    ),
	    Glamor.createElement(
	      "div",
	      { css: _ref4 },
	      Glamor.createElement(_Footer2.default, null)
	    )
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a069d1d22fc49257a390.js